/**
 * The table's scope/filter/search/pagination all run client-side, so the whole
 * cohort is fetched at once. 1000 is the endpoint's ceiling for `page_size`.
 */
export const CAMPAIGN_LIST_PAGE_SIZE = 1000;

export const metricOptionsBase = [
  { value: "delivered", key: "delivered", labelKey: "delivered" },
  { value: "openRate", key: "open_rate", labelKey: "openRate" },
  { value: "clickRate", key: "ctr", labelKey: "ctr" },
  { value: "bounceRate", key: "bounce_rate", labelKey: "bounceRate" },
  { value: "conversionRate", key: "conversion_rate", labelKey: "conversionRate" },
  { value: "unsubscribeRate", key: "unsubscribe_rate", labelKey: "unsubscribeRate" },
];

export const campaignDashboardTranslationKeys = [
  "openRate",
  "clickRate",
  "ctr",
  "conversionRate",
  "bounceRate",
  "delivered",
  "unsubscribeRate",
  "shareRate",
  "deleteCampaign",
  "archiveCampaign",
  "unarchiveCampaign",
  "campaignAction",
  "delete",
  "archive",
  "unarchive",
  "confirm",
  "deleting",
  "archiving",
  "unarchiving",
  "processing",
  "noCampaignsAvailable",
  "errorFetchingCampaigns",
  "defaultCampaignName",
  "campaignDeletedSuccess",
  "campaignArchivedSuccess",
  "campaignUnarchivedSuccess",
  "campaignsDeletedSuccess",
  "campaignsArchivedSuccess",
  "campaignsUnarchivedSuccess",
  "failedToActionCampaign",
  "errorActioningCampaign",
  "exportFilename",
  "singleExportFilename",
  "selectAtLeastOneDelete",
  "selectAtLeastOneArchive",
  "campaignName",
  "sentOn",
  "scheduledAt",
  "audience",
  "actions",
  "tooltipUnarchive",
  "tooltipArchive",
  "tooltipDelete",
  "tooltipDownload",
  "tooltipView",
  "confirmMany",
  "thisCampaign",
  "confirmOne",
  "bannerText",
  "dismissSummary",
  "campaignPerformance",
  "trackEmailCampaigns",
  "archivedCampaigns",
  "activeCampaigns",
  "viewActiveCampaigns",
  "viewArchivedCampaigns",
  "search",
  "chartTitle",
  "cancel",
  "atWord",
  "achievementsSubtitle",
  "filterCampaignName",
  "filterAllCampaigns",
  "filterSource",
  "filterStatus",
  "filterAll",
  "filterAllSources",
  "filterAllStatus",
  "scheduled",
  "draft",
  "untitledCampaign",
  "editDraft",
  "draftsCannotBeArchived",
  "draftOpenFailed",
  "whatsappDraftUnavailable",
  "campaignNotGenerated",
  "unscheduled",
  "whatsapp",
  "email",
  "pageOf",
  "tabActive",
  "tabArchive",
  "export",
  "campaignComparison",
  "achievementsLoadFailed",
  "conversions",
  "totalAudience",
  "totalUsersOnWebsite",
  "newUsers",
  "totalEmailsSent",
  "opens",
  "repeatedUsers",
  "metricForThisCampaign",
  "metricUnavailable",
  "metricUnavailableFallback",
  "sent",
  "collapseRow",
  "expandRow",
] as const;
